import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] p-4">
      <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-2xl p-8 text-center">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto" />
        <div className="mt-6 font-display font-black text-3xl uppercase">
          Paiement annulé
        </div>
        <div className="mt-2 text-sm text-slate-400">
          Vous pouvez réessayer à tout moment.
        </div>
        <button
          data-testid="cancel-back"
          onClick={() => nav("/paiement")}
          className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white font-bold uppercase tracking-wide"
        >
          <ArrowLeft className="w-4 h-4" /> Retour au paiement
        </button>
      </div>
    </div>
  );
}
